module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list complaints_List feedBack_list"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    class: {
      on: _vm.resultFeedBack == 1
    },
    on: {
      "click": function($event) {
        return _vm.selected('good')
      }
    }
  }, [_c('span', {
    staticClass: "feedBack_con fl"
  }, [_vm._v("满意")]), _c('span', {
    staticClass: "feedBack_icon fr"
  })]), _vm._v(" "), _c('li', {
    class: {
      on: _vm.resultFeedBack == 2
    },
    on: {
      "click": function($event) {
        return _vm.selected('bad')
      }
    }
  }, [_c('span', {
    staticClass: "feedBack_con fl"
  }, [_vm._v("不满意")]), _c('span', {
    staticClass: "feedBack_icon fr"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "feedBack_submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-08d51883","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/FeedBack.vue
// module id = 408
// module chunks = 7